module.exports = __webpack_public_path__ + "img/multi-location.a383b233.svg";